
















































































































































































































































































































































































































































































import BaseDialog from '@/components/BaseDialog.vue';
import VExtendedDataPicker from '@/components/VExtendedDataPicker.vue';
import AudioPlayerBtn from '@/components/media/AudioPlayerBtn.vue';
import CopyStakeAutoclickerPromptsModal from '@/views/CopyStake/CopyStakeAutoclicker/AiStreamers/CopyStakeAutoclickerPromptsModal.vue';

import { PropType } from 'vue';
import {
  EStreamerType,
  EStreamingType,
  IStreamerListResponse,
  TAutoclickerAvatarRecord,
  TAutoclickerCountryRecord,
  TAutoclickerGameData,
  TAutoclickerScriptRecord,
  TAutoclickerTemplate,
  TAutoclickerVoiceRecord,
  TCopyStakeSettingsBetVolumesResponse,
  TStreamer,
  TWebAiStreamerPayload,
  ValidationRules
} from '@/api/schema';
import * as vr from '@/helpers/validation';
import {
  createWebAiStreamer,
  deleteWebAiStreamer,
  getStreamersList,
  validateStreamer
} from '@/api/CopyStake/Streamers';
import { AxiosError } from 'axios';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import { mapGetters, mapState } from 'vuex';
import { getBetVolumesConfiguration } from '@/api/CopyStake/Settings';
import { DateTime } from 'luxon';
import {
  TAiStreamer,
  TAiStreamerPayload,
  TIMEZONES
} from '@/views/CopyStake/CopyStakeAutoclicker/types';
import {
  createAiStreamerConfig,
  deleteAutoclickerScript,
  getAutoclickerAvatarsList,
  getAutoclickerCountriesList,
  getAutoclickerScriptList,
  getAutoclickerTemplates,
  getAutoclickerVoicesList
} from '@/api/CopyStake/AutoClicker';

import { textOverflowMiddle, truncateString } from '@/helpers/formatString';
import { getLangCode, LANGUAGES } from '@/helpers/langHelpers';
import { cloneDeep } from 'lodash';

interface ActivatorOn {
  click?: (
    event?:
      | MouseEvent
      | { stopPropagation: () => void; preventDefault: () => void }
  ) => void;
}

const CopyStakeWebAiStreamerProfileEditDialog = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeAutoclicker/WebAiStreamerProfiles/CopyStakeWebAiStreamerProfileEditDialog.vue'
  );
const CopyStakeWebAiStreamerProfileForm = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeAutoclicker/WebAiStreamerProfiles/CopyStakeWebAiStreamerProfileForm.vue'
  );
const VStatus = (): Promise<any> => import('@/components/VStatus.vue');
const ConfirmationDialog = (): Promise<any> =>
  import('@/components/ConfirmationDialog.vue');

const DEFAULT_MIN_BALANCE_AMOUNT = 10000;
const DEFAULT_BET_AMOUNT = 0.5;
const DEFAULT_CURRENCY = 'USD';
const DEFAULT_ZONE = 'UTC';

export const NO_AVATAR_ID = 'NO_AVATAR';

export const startTimeSelectionList = [
  { text: 'Start now', value: 'now' },
  { text: 'Custom time', value: 'custom' }
];

const EStreamerRadioGroupKey = {
  EXISTING_STREAMER: 'EXISTING_STREAMER',
  NEW_STREAMER: 'NEW_STREAMER'
};

const STREAMER_TYPE_MAP = {
  [EStreamerType.PRIVATE]: {
    label: 'Private',
    type: 'system-success'
  },
  [EStreamerType.PUBLIC]: {
    label: 'Public',
    type: 'additional-finished'
  }
};

const defaultFormAiStreamerData = (): Partial<TAiStreamer> => {
  return {
    id: null,
    streamerId: '',
    supportedGameIds: [],
    minBalanceAmount: DEFAULT_MIN_BALANCE_AMOUNT,
    defaultBetAmount: DEFAULT_BET_AMOUNT,
    currency: DEFAULT_CURRENCY,
    scenarioTemplateId: '',
    startTime: '',
    startNow: false,
    endTime: '',
    zone: DEFAULT_ZONE,
    countryId: '',
    baseScriptId: '',
    heygenAvatarId: '',
    heygenVoiceId: '',
    voiceLanguage: ''
  };
};

const defaultFormWebAiStreamerProfileData =
  (): Partial<TWebAiStreamerPayload> => {
    return {
      nickname: '',
      operatorUserId: '',
      accessCode: '',
      type: EStreamerType.PUBLIC,
      shortBio: '',
      login: '',
      password: '',
      language: '',
      streamingType: EStreamingType.WEB_AI
    };
  };

export default {
  name: 'CopyStakeAiStreamerEditModal',
  components: {
    CopyStakeAutoclickerPromptsModal,
    CopyStakeWebAiStreamerProfileEditDialog,
    CopyStakeWebAiStreamerProfileForm,
    ConfirmationDialog,
    BaseDialog,
    AudioPlayerBtn,
    VExtendedDataPicker,
    VStatus
  },
  props: {
    form: {
      type: Object as PropType<Partial<TAiStreamer>>,
      default: defaultFormAiStreamerData
    },
    games: {
      type: Array as PropType<TAutoclickerGameData[]>,
      default: (): TAutoclickerGameData[] => []
    },
    value: {
      type: Boolean,
      default: (): boolean => false
    }
  },
  data(): any {
    return {
      dialogs: {
        webAiStreamerProfileCreateEdit: false,
        confirm: false,
        loading: false,
        data: undefined
      },

      EStreamerRadioGroupKey,
      STREAMER_TYPE_MAP,
      startTimeSelectionList,
      currentStep: 1,
      startTimeSelection: null,
      selectStreamerRadioGroup: EStreamerRadioGroupKey.EXISTING_STREAMER,

      formDataAiStreamer: defaultFormAiStreamerData(),
      isFormAiStreamerValid: true,
      currencyList: [DEFAULT_CURRENCY],
      scenarioList: [],
      countriesList: [],
      promptsList: [],
      avatarsList: [],
      voicesList: [],
      timezoneList: TIMEZONES,
      isShowPromptsModal: false,
      promptEditData: null,
      serverError: {
        nickname: null,
        operatorUserId: null,
        accessCode: null,
        type: null,
        shortBio: null,
        language: null
      },

      formDataWebAiStreamerProfile: defaultFormWebAiStreamerProfileData(),
      webAiStreamersProfilesList: null,

      loading: {
        configuration: false,
        templates: false,
        countries: false,
        prompts: false,
        avatars: false,
        voices: false,
        loadWebAiStreamersProfiles: false,
        processing: false
      }
    };
  },
  computed: {
    ...mapState('Operator', ['languages']),
    ...mapGetters('Onboarding', [
      'operatorId',
      'isUndergroundCasinoGamesIntegrationType'
    ]),

    operatorLanguages(): any {
      return LANGUAGES.filter((lang) => this.languages.includes(lang.value));
    },
    currentVoiceLanguagesList(): any[] {
      const selectedVoice = this.voicesList.find(
        (voice: TAutoclickerVoiceRecord) =>
          voice.heygenVoiceId === this.formDataAiStreamer?.heygenVoiceId
      );

      if (!selectedVoice) {
        return [];
      }

      const voiceLanguages = Object.entries(selectedVoice.voicePreviews).map(
        ([language, voicePreviewUrl]) => ({
          language: language,
          voicePreviewUrl: voicePreviewUrl || null,
          languageCode: getLangCode(language)
        })
      );

      return voiceLanguages.sort((a, b) => {
        if (a.language === 'English') return -1;
        if (b.language === 'English') return 1;
        return a.language.localeCompare(b.language);
      });
    },
    currentAvatarPreviewUrl(): string | null {
      return (
        this.avatarsList?.find(
          ({ heygenAvatarId }) =>
            heygenAvatarId === this.formDataAiStreamer?.heygenAvatarId
        )?.imageUrl || require('@/assets/images/autoclicker-avatar.png')
      );
    },
    currentVoicePreviewUrl(): string | null {
      return (
        this.currentVoiceLanguagesList?.find(
          ({ language }) =>
            language === this.formDataAiStreamer?.voiceLanguage
        )?.voicePreviewUrl || null
      );
    },

    isHideBaseModal(): boolean {
      return (
        this.isShowPromptsModal ||
        this.dialogs.webAiStreamerProfileCreateEdit ||
        this.dialogs.confirm
      );
    },
    isNewConfig(): boolean {
      return !this.formDataAiStreamer.id;
    },
    isLoading(): boolean {
      return Object.values(this.loading).some(Boolean);
    },

    formAiStreamerPayload(): TAiStreamerPayload {
      return {
        ...this.formDataAiStreamer,
        startTime: this.formDataAiStreamer.startNow
          ? null
          : this.formDataAiStreamer.startTime + ':00',
        endTime: this.formDataAiStreamer.endTime + ':00'
      };
    },

    dateStreamerNow(): string {
      return DateTime.now()
        .setZone(this.formDataAiStreamer.zone)
        .toFormat('yyyy-MM-dd HH:mm');
    },

    rules(): ValidationRules {
      return {
        avatarId: [(v: string) => vr.required(v, 'Avatar')],
        voice: [(v: string) => vr.required(v, 'Voice')],
        voiceLanguage: [(v: string) => vr.required(v, 'Language')],
        supportedGameIds: [
          (v: any) => (v && v.length > 0) || 'Game is required'
        ],
        minBalanceAmount: [
          (v: string) => vr.required(v, 'Min Balance Amount'),
          vr.positiveNumber
        ],
        defaultBetAmount: [
          (v: string) => vr.required(v, 'Default Bet Amount'),
          vr.positiveNumber
        ],
        startTime: this.formDataAiStreamer.startNow
          ? [
              () =>
                vr.required(this.formDataAiStreamer.startTime, 'Start Time')
            ]
          : [
              () =>
                vr.required(this.formDataAiStreamer.startTime, 'Start Time'),
              () => {
                const isValid =
                  vr.isDateTimeAfterOrEqual(
                    this.formDataAiStreamer.startTime,
                    this.dateStreamerNow
                  ) === true &&
                  vr.isDateNotEqual(
                    this.formDataAiStreamer.startTime,
                    this.dateStreamerNow
                  ) === true;

                return isValid === true
                  ? true
                  : 'Start date must be in the future';
              }
            ],
        endTime: this.formDataAiStreamer.startNow
          ? [
              (v: string) => vr.required(v, 'End Time'),
              (v) => vr.isDateNotEqual(v, this.dateStreamerNow),
              (v) => vr.isDateTimeAfterOrEqual(v, this.dateStreamerNow)
            ]
          : [
              (v: string) => vr.required(v, 'End Time'),
              (v) => vr.isDateNotEqual(v, this.formDataAiStreamer.startTime),
              (v) =>
                vr.isDateTimeAfterOrEqual(
                  v,
                  this.formDataAiStreamer.startTime
                )
            ],
        country: [(v: string) => vr.required(v, 'Country')],
        prompts: [(v: string) => vr.required(v, 'AI Streamer Script')],
        zone: [(v: string) => vr.required(v, 'Timezone')],
        scenario: [(v: string) => vr.required(v, 'AI Avatar behaviour')],
        streamerId:
          this.selectStreamerRadioGroup ===
          EStreamerRadioGroupKey.EXISTING_STREAMER
            ? [(v: string) => vr.required(v, 'Streamer')]
            : []
      };
    }
  },
  watch: {
    async value(open: boolean): Promise<void> {
      await this.resetAiStreamerForm();
      await this.resetWebAiStreamerProfileForm();
      this.currentStep = 1;
      this.selectStreamerRadioGroup =
        EStreamerRadioGroupKey.EXISTING_STREAMER;

      if (!open) {
        return;
      }

      this.formDataAiStreamer = {
        ...this.form,
        startTime: this.form?.startTime?.slice(0, 16),
        endTime: this.form?.endTime.slice(0, 16)
      };

      if (this.form.supportedGameIds && this.form.supportedGameIds.length) {
        const availableIds = new Set(
          (this.games || []).map((g: TAutoclickerGameData) => g.id)
        );
        this.formDataAiStreamer.supportedGameIds =
          this.form.supportedGameIds.filter((id: number) =>
            availableIds.has(id)
          );
      }

      if (!this.scenarioList.length) {
        this.getTemplates();
      }

      if (this.currencyList.length <= 1) {
        this.getConfiguration();
      }

      if (this.countriesList.length <= 1) {
        this.getCountries();
      }

      if (this.avatarsList.length <= 1) {
        this.getAvatars();
      } else {
        this.setPredefinedAvatar();
      }

      if (this.voicesList.length <= 1) {
        this.getVoices();
      } else {
        this.setPredefinedVoice();
      }

      if (!this.webAiStreamersProfilesList) {
        this.fetchWebAiStreamerProfilesData();
      }
    },
    'formDataAiStreamer.zone'(): void {
      this.validateDate('startTime');
      this.validateDate('endTime');
    },
    'formDataAiStreamer.startTime'(): void {
      this.validateDate('endTime');
    },
    'formDataAiStreamer.endTime'(): void {
      this.validateDate('startTime');
    },
    async 'formDataAiStreamer.voiceLanguage'(): Promise<void> {
      await this.getPrompts();

      this.setDefaultPrompt();
    }
  },
  methods: {
    truncateString,
    textOverflowMiddle,

    async getConfiguration(): Promise<void> {
      if (!this.operatorId) {
        return;
      }

      this.loading.configuration = true;

      getBetVolumesConfiguration()
        .then((data: TCopyStakeSettingsBetVolumesResponse) => {
          if (data) {
            this.currencyList = Object.keys(data);
          }
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.loading.configuration = false;
        });
    },
    async getTemplates(): Promise<void> {
      this.loading.templates = true;

      getAutoclickerTemplates()
        .then((data: TAutoclickerTemplate[]): void => {
          this.scenarioList = data;
        })
        .catch(() => {
          this.scenarioList = [];
        })
        .finally(() => {
          this.loading.templates = false;
        });
    },
    async getCountries(): Promise<void> {
      this.loading.countries = true;

      getAutoclickerCountriesList()
        .then((data: TAutoclickerCountryRecord[]): void => {
          this.countriesList = data;
        })
        .catch(() => {
          this.countriesList = [];
        })
        .finally(() => {
          this.loading.countries = false;
        });
    },
    async getPrompts(id: number): Promise<void> {
      if (!this.formDataAiStreamer.voiceLanguage) return;

      this.loading.prompts = true;

      return getAutoclickerScriptList(this.formDataAiStreamer.voiceLanguage)
        .then((data: TAutoclickerScriptRecord[]): void => {
          this.promptsList = data;

          if (id) this.formDataAiStreamer.baseScriptId = id;
        })
        .catch(() => {
          this.promptsList = [];
        })
        .finally(() => {
          this.loading.prompts = false;
        });
    },
    async getAvatars(): Promise<void> {
      this.loading.avatars = true;

      getAutoclickerAvatarsList()
        .then((data: TAutoclickerAvatarRecord[]): void => {
          this.avatarsList = data.sort((a, b) =>
            a.avatarName.localeCompare(b.avatarName)
          );

          this.setPredefinedAvatar();
        })
        .catch(() => {
          this.avatarsList = [];
        })
        .finally(() => {
          this.loading.avatars = false;
        });
    },
    async getVoices(): Promise<void> {
      this.loading.voices = true;

      getAutoclickerVoicesList()
        .then((data: TAutoclickerVoiceRecord[]): void => {
          this.voicesList = data || [];

          this.setPredefinedVoice();
        })
        .catch(() => {
          this.voicesList = [];
        })
        .finally(() => {
          this.loading.voices = false;
        });
    },
    async fetchWebAiStreamerProfilesData(): Promise<void> {
      if (!this.operatorId) return;

      this.loading.loadWebAiStreamersProfiles = true;

      getStreamersList({
        size: 1000,
        page: 0,
        operatorId: this.operatorId,
        streamingType: EStreamingType.WEB_AI
      })
        .then((data: IStreamerListResponse) => {
          this.webAiStreamersProfilesList = data.content
            .filter(({ nickname }) => !!nickname)
            .map((item: TStreamer) => ({
              ...item,
              text: item.nickname,
              value: item.id,
              type: item.type
            }));
        })
        .catch((error: AxiosError): void => {
          errorToastMessage(error);
        })
        .finally(() => {
          this.loading.loadWebAiStreamersProfiles = false;
        });
    },

    setPredefinedAvatar(): void {
      if (
        this.isNewConfig &&
        this.avatarsList.length &&
        !this.formDataAiStreamer.heygenAvatarId
      ) {
        this.formDataAiStreamer.heygenAvatarId =
          this.avatarsList[0]?.heygenAvatarId || null;
      }
    },
    setPredefinedVoice(): void {
      if (!this.voicesList.length) return;

      if (this.isNewConfig && !this.formDataAiStreamer.heygenVoiceId) {
        this.formDataAiStreamer.heygenVoiceId =
          this.voicesList[0]?.heygenVoiceId || null;

        this.formDataAiStreamer.voiceLanguage =
          this.currentVoiceLanguagesList[0]?.language || null;
      } else {
        const originalHeygenVoiceId = this.voicesList?.find(
          (voice: TAutoclickerVoiceRecord) =>
            (this.form?.heygenAvatarId === NO_AVATAR_ID
              ? voice.elevenlabVoiceId
              : voice.heygenVoiceId) === this.form?.heygenVoiceId
        )?.heygenVoiceId;

        this.formDataAiStreamer.heygenVoiceId = originalHeygenVoiceId || '';
      }
    },
    setDefaultPrompt(): void {
      if (
        (!this.isNewConfig && !this.formDataAiStreamer.baseScriptId) ||
        !this.promptsList?.length
      ) {
        this.formDataAiStreamer.baseScriptId = null;

        return;
      }

      const hasFormBaseId = !!this.form?.baseScriptId;
      if (hasFormBaseId) {
        const found = this.promptsList.find(
          (script: TAutoclickerScriptRecord) =>
            script.id === this.form.baseScriptId
        );
        if (found) {
          this.formDataAiStreamer.baseScriptId = found.id;
          this.$nextTick(() => {
            this.$refs.promptsInput?.validate();
          });
          return;
        }
      }

      const systemPrompt = this.promptsList.find(
        (script: TAutoclickerScriptRecord) => script.isSystem
      );
      this.formDataAiStreamer.baseScriptId = systemPrompt
        ? systemPrompt.id
        : null;
      this.$nextTick(() => {
        this.$refs.promptsInput?.validate();
      });
    },
    changeHeygenVoice(): void {
      const languageExists = this.currentVoiceLanguagesList.some(
        (item) => item.language === this.formDataAiStreamer.voiceLanguage
      );

      if (!languageExists) {
        this.formDataAiStreamer.voiceLanguage =
          this.currentVoiceLanguagesList[0]?.language || '';
      }
    },
    selectStartTimeHandler(value: string, on: ActivatorOn): void {
      this.startTimeSelection = value;
      this.$refs.startTime?.blur();

      if (value === 'now') {
        this.formDataAiStreamer.startTime = 'Start now';
        this.formDataAiStreamer.startNow = true;
      }

      if (value === 'custom' && on && typeof on.click === 'function') {
        this.formDataAiStreamer.startNow = false;

        on.click({
          stopPropagation: () => undefined,
          preventDefault: () => undefined
        });
      }
    },
    addNewPromptsHandler(): void {
      this.promptEditData = null;
      this.isShowPromptsModal = true;
    },
    copyPromptsHandler(item: TAutoclickerScriptRecord): void {
      this.$refs.promptsInput.isMenuActive = false;

      this.promptEditData = {
        ...cloneDeep(item),
        id: null,
        name: item.name + ' - Copy'
      };
      this.isShowPromptsModal = true;
    },
    editPromptsHandler(item: TAutoclickerScriptRecord): void {
      this.$refs.promptsInput.isMenuActive = false;

      this.promptEditData = cloneDeep(item);
      this.isShowPromptsModal = true;
    },
    deletePromptsHandler(item: TAutoclickerScriptRecord): void {
      this.$refs.promptsInput.isMenuActive = false;
      this.dialogs.confirm = true;

      this.dialogs.data = {
        disclaimer: `
            <p>
              Are you sure you want to delete the <strong>${item.name}</strong> script?
            </p>`,
        header: 'Delete Script',
        okText: 'Delete',
        maxWidth: '640',
        handler: async () => {
          try {
            this.dialogs.loading = true;

            if (this.formDataAiStreamer.baseScriptId === item.id) {
              this.formDataAiStreamer.baseScriptId = null;
            }
            await deleteAutoclickerScript(item.id);
            this.getPrompts();
            this.$toast.success(
              `"${item.name}" script was successfully deleted`
            );

            this.closeDialog('confirm');
          } catch (error) {
            errorToastMessage(error);
          } finally {
            this.dialogs.loading = false;
          }
        }
      };
    },
    removeGameItem({ id }: { id: number }): void {
      this.formDataAiStreamer.supportedGameIds =
        this.formDataAiStreamer.supportedGameIds.filter(
          (gameId: number) => gameId !== id
        );
    },
    async resetAiStreamerForm(): Promise<void> {
      await this.$refs.aiStreamerFormStep1?.reset();

      this.formDataAiStreamer = {
        ...this.formDataAiStreamer,
        ...defaultFormAiStreamerData()
      };
    },
    async resetWebAiStreamerProfileForm(): Promise<void> {
      await this.$refs.webAiStreamerProfileForm?.reset();
      await this.$refs.aiStreamerFormStep2?.reset();

      this.resetServerErrors();

      this.formDataWebAiStreamerProfile = {
        ...defaultFormAiStreamerData()
      };
    },
    resetServerErrors(): void {
      this.serverError = {
        nickname: null,
        accessCode: null,
        operatorUserId: null,
        type: null,
        shortBio: null,
        language: null
      };
    },
    parseServerErrors(error: AxiosError): void {
      if (error instanceof AxiosError) {
        const errorMessage = error.response?.data?.message;
        if (!errorMessage) return;

        if (
          errorMessage.includes('Streamer with access code') ||
          errorMessage.includes('Streamer with accessCode')
        ) {
          this.serverError.accessCode = errorMessage;
        }

        if (errorMessage.includes('Streamer with nickname')) {
          this.serverError.nickname = errorMessage;
        }

        if (errorMessage.includes('Streamer with user')) {
          this.serverError.operatorUserId = errorMessage;
        }

        if (errorMessage.includes('User by operatorUserId')) {
          this.serverError.operatorUserId = errorMessage;
        }

        if (errorMessage.includes('shortBio')) {
          this.serverError.shortBio = errorMessage;
        }
      }
    },
    validateDate(type: string): void {
      if (this.formDataAiStreamer[type]?.length !== 0) {
        this.$refs[type].validate();
      }
    },

    async handleClickNextBtn(): Promise<void> {
      await this.$refs.aiStreamerFormStep1.validate();

      if (!this.isFormAiStreamerValid) return;

      this.currentStep += 1;
    },
    handlerOnCreateEditWebAiStreamerProfile(
      webAiStreamerProfile?: TStreamer
    ): void {
      if (webAiStreamerProfile) {
        this.dialogs.data = webAiStreamerProfile;
      }

      this.dialogs.webAiStreamerProfileCreateEdit = true;
    },
    async handleSubmitCreateEditWebAiStreamerProfileDialog(): Promise<void> {
      await this.fetchWebAiStreamerProfilesData();
    },
    handlerOnDeleteWebAiStreamerProfile(
      webAiStreamerProfile: TStreamer
    ): void {
      this.dialogs.confirm = true;
      this.dialogs.data = {
        disclaimer: `
            <p>
              Are you sure you want to delete <strong>${webAiStreamerProfile.nickname}</strong> Streamer Profile?
            </p>
            <p class="text--disabled">You will not be able to recover it.</p>`,
        icon: 'mdi-alert-octagon',
        header: 'Delete Streamer Profile',
        okText: 'Delete',
        maxWidth: '640',
        handler: async () => {
          try {
            this.dialogs.loading = true;

            await deleteWebAiStreamer(webAiStreamerProfile.id);
            this.fetchWebAiStreamerProfilesData();
            this.$toast.success(
              `Streamer "${webAiStreamerProfile.nickname}" profile was successfully deleted`
            );

            this.closeDialog('confirm');
          } catch (error) {
            errorToastMessage(error);
          } finally {
            this.dialogs.loading = false;
          }
        }
      };
    },
    async handleSubmit(): Promise<void> {
      this.isFormAiStreamerValid =
        await this.$refs.aiStreamerFormStep2.validate();

      if (!this.isFormAiStreamerValid || this.loading.processing) return;

      if (
        this.selectStreamerRadioGroup === EStreamerRadioGroupKey.NEW_STREAMER
      ) {
        try {
          this.resetServerErrors();
          const isValid = await (
            this.$refs.webAiStreamerProfileForm as any
          ).validate();

          if (!isValid || this.loading.processing) return;
          this.loading.processing = true;

          const payloadCreateWebAiStreamerProfile = {
            ...this.formDataWebAiStreamerProfile,
            accessCode:
              (this.formDataWebAiStreamerProfile.accessCode &&
                this.formDataWebAiStreamerProfile.accessCode.toUpperCase()) ||
              null
          };

          if (this.isUndergroundCasinoGamesIntegrationType) {
            payloadCreateWebAiStreamerProfile.login = null;
            payloadCreateWebAiStreamerProfile.password = null;
          }

          await validateStreamer({
            ...payloadCreateWebAiStreamerProfile,
            streamingType: EStreamingType.WEB_AI
          });

          const newWebAiStreamerProfile = await createWebAiStreamer(
            payloadCreateWebAiStreamerProfile
          );

          this.formDataAiStreamer.streamerId = newWebAiStreamerProfile.id;
        } catch (error) {
          this.parseServerErrors(error);
          errorToastMessage(error);
          return;
        } finally {
          this.loading.processing = false;
        }
      }
      this.loading.processing = true;

      if (this.isNewConfig) {
        createAiStreamerConfig(this.formAiStreamerPayload)
          .then(() => {
            this.$toast.success('AI Streamer Config created');
            this.$emit('update');
            this.closeModal();
          })
          .catch(errorToastMessage)
          .finally(() => {
            this.loading.processing = false;
          });
      }
    },

    closeDialog(type: string, resetData: boolean = true): void {
      this.dialogs[type] = false;

      if (resetData) {
        this.$nextTick(() => {
          this.dialogs.data = {};
        });
      }
    },
    closeModal(): void {
      this.$emit('input', false);
    }
  }
};
